import script from "./employee-details-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-details-modal.vue?vue&type=script&setup=true&lang=js"

import "./employee-details-modal.vue?vue&type=style&index=0&id=7efbb0f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7efbb0f1"]])

export default __exports__